import React, { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { convertSpecialPanelCheckedItemsToArray } from '@functional';

import Box from '@mui/material/Box';

import ConditionBox from '@ui-parts/ConditionBox';
import SpecialPanelModal from '@ui-parts/SpecialPanelModal';

import { SPECIAL_PANEL_DISPLAY_SETTING_IDS, SPECIAL_PANEL_CATEGORIES } from '~/constants';

const FlexBox = styled(Box)`
  display: flex;
  align-items: flex-start;
`;

const FlexItem = styled(Box)`
  width: 100%;
  flex-grow: 1;
  margin: 10px 0 0;
  padding: 0 5px;
`;

function DetailedConditionsAreaSpecialPanelOne({ checkedItems }) {
  const { t } = useTranslation();

  const SPECIAL_PANEL_DISPLAY_SETTING_ID = SPECIAL_PANEL_DISPLAY_SETTING_IDS.V1;

  const [openModals, setOpenModals] = useState({
    jobGroup: false,
    industry: false,
    marriageStatus: false,
    childrenStatus: false,
  });

  const [selectedChoiceNames, setSelectedChoiceNames] = useState({
    jobGroup: [],
    industry: [],
    marriageStatus: [],
    childrenStatus: [],
  });

  const selectedMarriageStatus = useMemo(() => {
    return convertSpecialPanelCheckedItemsToArray(
      checkedItems.marriageStatus,
      SPECIAL_PANEL_DISPLAY_SETTING_ID,
      true
    );
  }, [checkedItems.marriageStatus]);

  const selectedChildrenStatus = useMemo(() => {
    return convertSpecialPanelCheckedItemsToArray(
      checkedItems.childrenStatus,
      SPECIAL_PANEL_DISPLAY_SETTING_ID,
      true
    );
  }, [checkedItems.childrenStatus]);

  const selectedJobGroup = useMemo(() => {
    return convertSpecialPanelCheckedItemsToArray(
      checkedItems.jobGroup,
      SPECIAL_PANEL_DISPLAY_SETTING_ID,
      true
    );
  }, [checkedItems.jobGroup]);

  const selectedIndustry = useMemo(() => {
    return convertSpecialPanelCheckedItemsToArray(
      checkedItems.industry,
      SPECIAL_PANEL_DISPLAY_SETTING_ID,
      true
    );
  }, [checkedItems.industry]);

  useEffect(() => {
    setSelectedChoiceNames({
      jobGroup: selectedJobGroup,
      industry: selectedIndustry,
      marriageStatus: selectedMarriageStatus,
      childrenStatus: selectedChildrenStatus,
    });
  }, [selectedJobGroup, selectedIndustry, selectedMarriageStatus, selectedChildrenStatus]);

  return (
    <>
      <FlexBox>
        <FlexItem>
          <ConditionBox
            conditionLabel={t(`quotas.conditions.titles.jobGroup`)}
            selectedChoices={selectedChoiceNames.jobGroup}
            name="QuotaJobGroup"
            editable={selectedChoiceNames.jobGroup.length > 0}
            handleClickAddBtn={() => {
              setOpenModals({
                ...openModals,
                jobGroup: true,
              });
            }}
            handleClickEditBtn={() => {
              setOpenModals({
                ...openModals,
                jobGroup: true,
              });
            }}
          />
        </FlexItem>
      </FlexBox>

      <FlexBox>
        <FlexItem>
          <ConditionBox
            conditionLabel={t(`quotas.conditions.titles.industry`)}
            selectedChoices={selectedChoiceNames.industry}
            name="QuotaIndustry"
            editable={selectedChoiceNames.industry.length > 0}
            handleClickAddBtn={() => {
              setOpenModals({
                ...openModals,
                industry: true,
              });
            }}
            handleClickEditBtn={() => {
              setOpenModals({
                ...openModals,
                industry: true,
              });
            }}
          />
        </FlexItem>
      </FlexBox>

      <FlexBox>
        <FlexItem>
          <ConditionBox
            conditionLabel={t(`quotas.conditions.titles.marriageStatus`)}
            selectedChoices={selectedChoiceNames.marriageStatus}
            name="QuotaMarriageStatus"
            editable={selectedChoiceNames.marriageStatus.length > 0}
            handleClickAddBtn={() => {
              setOpenModals({
                ...openModals,
                marriageStatus: true,
              });
            }}
            handleClickEditBtn={() => {
              setOpenModals({
                ...openModals,
                marriageStatus: true,
              });
            }}
          />
        </FlexItem>

        <FlexItem>
          <ConditionBox
            conditionLabel={t(`quotas.conditions.titles.childrenStatus`)}
            selectedChoices={selectedChoiceNames.childrenStatus}
            name="QuotaChildrenStatus"
            editable={selectedChoiceNames.childrenStatus.length > 0}
            handleClickAddBtn={() => {
              setOpenModals({
                ...openModals,
                childrenStatus: true,
              });
            }}
            handleClickEditBtn={() => {
              setOpenModals({
                ...openModals,
                childrenStatus: true,
              });
            }}
          />
        </FlexItem>
      </FlexBox>

      {SPECIAL_PANEL_CATEGORIES[SPECIAL_PANEL_DISPLAY_SETTING_ID].map((questionKey) => (
        <SpecialPanelModal
          key={questionKey}
          open={openModals[questionKey]}
          handleClose={() => {
            setOpenModals({
              ...openModals,
              [questionKey]: false,
            });
          }}
          specialPanelDisplaySettingId={SPECIAL_PANEL_DISPLAY_SETTING_ID}
          questionKey={questionKey}
          checkedChoices={checkedItems[questionKey]}
        />
      ))}
    </>
  );
}

DetailedConditionsAreaSpecialPanelOne.propTypes = {
  // ↓i動的なのでいったんlintエラーは無視してobjectで定義
  // eslint-disable-next-line react/forbid-prop-types
  checkedItems: PropTypes.object.isRequired,
};

export default DetailedConditionsAreaSpecialPanelOne;
